import { Box } from "@mui/material";

import { VISIT_STATUS_TO_COLOR_MAP } from "~/config/statusColors";

type IconVisitProps = {
    status: keyof typeof VISIT_STATUS_TO_COLOR_MAP;
    size?: "normal" | "small";
};

export function IconVisit({ status, size = "normal" }: IconVisitProps) {
    const sizeInPixels = size === "normal" ? 40 : 24;
    return (
        <Box sx={{ display: "flex" }}>
            <svg
                width={sizeInPixels}
                height={sizeInPixels}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <title>{`Visit with status ${status}`}</title>
                <circle cx="12" cy="12" r="9.5" stroke={VISIT_STATUS_TO_COLOR_MAP[status]} strokeWidth="5" />
            </svg>
        </Box>
    );
}
